import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

const testimonials = [
  {
    img: "testi_1_1.jpg",
    title: "Comfortable Urbania Ride",
    text:
      "We booked Urbania on rent in Pune for a family trip. The seating was spacious, the ride was smooth, and the driver was very professional throughout the journey.",
    name: "Mr. Rahul Patil",
    role: "Software Engineer",
  },
  {
    img: "testi_1_2.jpg",
    title: "Best for Group Travel",
    text:
      "Urbania rental in Pune was perfect for our corporate tour. The vehicle was clean, service was on time, and overall comfort made the journey enjoyable for everyone.",
    name: "Miss Neha Sharma",
    role: "Doctor",
  },
  {
    img: "testi_1_3.jpg",
    title: "Luxury & Safety",
    text:
      "The Urbania bus was well-maintained and offered a luxurious experience. It is an ideal choice for weddings and long-distance journeys with complete safety and comfort.",
    name: "Mr. Sandeep Kulkarni",
    role: "Business Owner",
  },
  {
    img: "testi_1_1.jpg",
    title: "Affordable & Reliable",
    text:
      "Urbania on rent in Pune was available at a reasonable price. The billing was transparent, and the staff was very cooperative, making the entire travel experience smooth.",
    name: "Miss Pooja Deshmukh",
    role: "Teacher",
  },
  {
    img: "testi_1_2.jpg",
    title: "Perfect Wedding Transport",
    text:
      "We booked Urbania for wedding guests, and everyone appreciated the comfort. The journey was smooth, well-managed, and ensured all guests reached safely and on time.",
    name: "Mr. Amit Jadhav",
    role: "Event Planner",
  },
  {
    img: "testi_1_3.jpg",
    title: "Great Travel Experience",
    text:
      "Our trip with Urbania rental in Pune was excellent. The vehicle condition was top-notch, the driver was polite, and the entire journey was comfortable and stress-free.",
    name: "Mrs. Sneha Joshi",
    role: "HR Manager",
  },
];

const Testimonials = () => {
  return (
    <section
      className="testi-card-area-1 py-4 bg-smoke overflow-hidden"
      id="testi-sec"
    >
      {/* Shape */}
      <div className="shape-mockup" style={{ right: 0, top: 0 }}>
        <img
          src="/img/shape/testi-irhgt-shpae-bg.png"
          alt="shape-bg"
        />
      </div>

      <div className="container">
        {/* Title */}
        <div className="row justify-content-center">
          <div className="col-xxl-7 col-xl-7">
            <div className="title-area text-center section-header">
              <h2 className="sec-title ">Our Customer Feedback!</h2>
              <p>
                Many dealerships have service departments equipped with certified
                technicians who handle maintenance, repairs, oil changes, tire
                rotations, and other essential vehicle services.
              </p>
            </div>
          </div>
        </div>

        {/* Slider */}
        <div className="row justify-content-center">
          <div className="testi-card-slide position-relative">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              loop
              autoplay={{ delay: 3500, disableOnInteraction: false }}
              navigation={{
                nextEl: ".slider-next",
                prevEl: ".slider-prev",
              }}
              pagination={{
                el: ".slider-pagination",
                clickable: true,
              }}
              breakpoints={{
                0: { slidesPerView: 1 },
                768: { slidesPerView: 1 },
                992: { slidesPerView: 2 },
                1200: { slidesPerView: 3 },
              }}
              className="has-shadow"
            >
              {testimonials.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="testi-block" dir="ltr">
                    <div className="testi-block-top">
                      {/* <div className="box-img">
                        <img
                          src={`/img/testimonial/${item.img}`}
                          alt="avatar"
                        />
                      </div> */}

                      <div className="content">
                        <div className="box-review">
                          {[...Array(5)].map((_, i) => (
                            <i
                              key={i}
                              className="fa-sharp fa-solid fa-star"
                            ></i>
                          ))}
                          <div className="rating">
                            <span>4.0 / 5.0 Reviews</span>
                          </div>
                        </div>

                        <h3 className="box-title">{item.title}</h3>
                        <p className="box-text">“{item.text}”</p>

                        <div className="content-bottom">
                          <div className="left">
                            <h3 className="name-title">{item.name}</h3>
                           <p className="box-desig">{item.role}</p>
                          </div>
                          <div className="right">
                            <img
                              src="/img/icon/testi-quote-icon.png"
                              alt="quote"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            {/* Pagination & Arrows */}
            <div className="pagination-count-wrap border-style">
              <div className="pagination-wrap">
                <div className="slider-pagination"></div>
              </div>
            </div>

            {/* <button className="slider-arrow slider-prev">
              <i className="far fa-arrow-left"></i>
            </button>
            <button className="slider-arrow slider-next">
              <i className="far fa-arrow-right"></i>
            </button> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;